import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Input, Select, Textarea } from '../../../components/base/index';

export default function BuatDaftarForm(props) {


  const { onFormChange, form } = props;
  return (
    <div className="nilai-kognitif__custom-form">
      <div className="nilai-kognitif__custom-form-row">
        <div className="nilai-kognitif__custom-form-row__field">
          <Input
            name="namaSaudara1"
            label="Kode Unit Perpustakaan"
            onChange={onFormChange}
            data={ '7A', 'kelas7a'}
            placeholder={'Kelas 7A'}
           
            // error={form.error.namaSaudara1 || ''}
          />
        </div>
        
        <div className="nilai-kognitif__custom-form-column__field">
            
          <Input
           
            name="tahunajaran"
            label="Nama Perpustakaan"
            onChange={onFormChange}
            value={form.value.tempatLahirSaudara1 || ''}
            error={form.error.tempatLahirSaudara1 || ''}
            placeholder={'2019 - 2020'}
          />
          
       
         
        </div>
        </div>
        <div className="nilai-kognitif__custom-form-row">
        <div className="nilai-kognitif__custom-form-row__field">
          <Input
            name="namaSaudara1"
            label="Maximum Jumlah Pinjam (Buku)"
            onChange={onFormChange}
            data={ '7A', 'kelas7a'}
            placeholder={'Praktek/Keterampilan/Kl 4'}
           
            // error={form.error.namaSaudara1 || ''}
          />
        </div>
        
        <div className="nilai-kognitif__custom-form-column__field">
            
          <Input
           
            name="tahunajaran"
            label="PerioMaximum Lama Pinjam (Hari)"
            onChange={onFormChange}
            value={form.value.tempatLahirSaudara1 || ''}
            error={form.error.tempatLahirSaudara1 || ''}
            placeholder={'Pilihan'}
          />
          
       
         
        </div>
        </div>
        <div className="nilai-kognitif__custom-form-row">
        <div className="nilai-kognitif__custom-form-row__field">
          <Input
            name="namaSaudara1"
            label="Jumlah Denda (Rp)"
            onChange={onFormChange}
            data={ '7A', 'kelas7a'}
            placeholder={'Pilihan'}
           
            // error={form.error.namaSaudara1 || ''}
          />
        </div>
        
        <div className="nilai-kognitif__custom-form-column__field">
            
          <Input
           
            name="tahunajaran"
            label="JUmlah Uang Pinjam (Rp)"
            onChange={onFormChange}
            value={form.value.tempatLahirSaudara1 || ''}
            error={form.error.tempatLahirSaudara1 || ''}
            placeholder={'Pilihan'}
          />
          
       
         
        </div>
        </div>
        
        </div>
        
 
   
  );
}
BuatDaftarForm.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
BuatDaftarForm.defaultProps = {
  onFormChange: noop,
};
